import Step from "@material-ui/core/Step/Step";
import StepButton from "@material-ui/core/StepButton";
import Stepper from "@material-ui/core/Stepper";
import Typography from "@material-ui/core/Typography/Typography";
import { useTranslation } from "react-i18next";
import { ROUTES } from "@constants";
import "./css/stepperComponent.scss";
import { useHistory } from "react-router-dom";
import { fixUrlLanguage } from "@utils/changeLanguage";

interface IParams {
    activeStep: number;
    title?: string;
}

export const StepperComponent = (props: IParams) => {
    const { title, activeStep } = props;
    const mobileDisplay = window.innerWidth <= 768;
    const { t } = useTranslation(["cart", "customerDetails", "glossary"]);
    const { push } = useHistory();

    const steps = [
        { key: 0, label: t("cart:planSelection"), route: fixUrlLanguage(ROUTES.CART_PAGE_URL_EN) },
        { key: 1, label: t("customerDetails:customerDetails"), route: fixUrlLanguage(ROUTES.DETAILS_PAGE_URL_EN) },
        { key: 2, label: t("glossary:payment"), route: fixUrlLanguage(ROUTES.SUMMARY_PAGE_URL_EN) },
        { key: 3, label: t("glossary:confirmation"), route: fixUrlLanguage(ROUTES.CONFIRMATION_PAGE_URL_EN) },
    ];

    return (
        <div className="stepper">
            <Stepper activeStep={activeStep} alternativeLabel={mobileDisplay}>
                {steps.map((step) => (
                    <Step key={step.key}>
                        <StepButton onClick={() => push(step.route)}>{step.label}</StepButton>
                    </Step>
                ))}
            </Stepper>
            {title && (
                <Typography align="center" className="stepper__title" color="secondary" variant="h1">
                    {steps[activeStep].label}
                </Typography>
            )}
        </div>
    );
};
